<template>
  <div v-if="show" class="info-wrapper" v-bind:class="{'warn': message.isWarn}">
    <div class="flex">
      <i
        class="fas fa-exclamation-triangle "
        style="font-size: 20px;color: orange;margin: 0px 15px 0px 5px;"
      ></i>
      <div style="margin: 5px 0;">
        <div class="title" v-html="message.title"></div>
        <div v-html="message.displayText"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "infobox",
  props: {
    message: {
      displayText: String,
      isWarn: Boolean,
      timer: Number
    }
  },
  data: function() {
    return {
      show: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, this.timer || 100);
  }
};
</script>
<style scoped lang="scss">
@keyframes kf-height-adjust {
  0% {
    height: 0px;
    opacity: 0;
    font-size: 0;
    min-height: 0px;
  }
  100% {
    height: initial;
    width: initial;
    opacity: 1;
    font-size: 14px;
    min-height: 40px;
  }
}

.info-wrapper.warn {
  //background-color: #ffd9a0;
  background-color: #fff8e8;

  .nc-icon {
    color: #fff;
    display: flex;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    background-color: #fea012;
  }
}

.info-wrapper {
  //width: 100%;
  min-height: 40px;
  text-align: left;
  //border-left: 5px solid #d9d38d;
  border: 1px solid #f8e2af;
  padding: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #fff8e8;
  color: #847969;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 1s ease 0.3s;
  animation: kf-height-adjust 0.3s 1 linear;
  margin: 5px 30px;
}
.flex {
  display: flex;
  align-items: center;
}
.title {
  font-weight: bold;
  color: #555;
}
</style>
